import { render } from "./CommitmentPlaceholder.vue?vue&type=template&id=9bc962e4&scoped=true"
import script from "./CommitmentPlaceholder.vue?vue&type=script&lang=js"
export * from "./CommitmentPlaceholder.vue?vue&type=script&lang=js"

import "./CommitmentPlaceholder.vue?vue&type=style&index=0&id=9bc962e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9bc962e4"

export default script